
import { CreatomateFont, BuiltInFontDefinition } from "./BuiltInFonts";

export const CreatomateVerizonFonts: CreatomateFont[] = [
  {
    family: "Verizon NHG DS",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/VerizonNHGDS-Bold.ttf"
  },
  {
    family: "Verizon NHG DS Normal ",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/VerizonNHGDS-Regular.ttf"
  }
];

export const BuiltInVerizonFonts: BuiltInFontDefinition[] = [
  {
    family: "Verizon NHG DS",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/VerizonNHGDS-Bold.ttf"
  },
  {
    family: "Verizon NHG DS Normal ",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/VerizonNHGDS-Regular.ttf"
  }
];
